const state = {
  selectedPurchase: {}
}

const mutations = {
  SET_SELECTED_PURCHASE (state, purchase) {
    state.selectedPurchase = purchase
  }
}

export default { mutations, state }
